<template>
  <div class="tell">
    <div class="tell_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">通知</div>
    </div>
    <div class="tell_bottom">
      <div
        class="tell_bottom_list"
        v-for="item in tell_list"
        :key="item.id"
        :style="{ color: item.isRead === true ? '#999999' : '#333333' }"
        @click="getDetails(item.id)"
      >
        <p>{{ item.title }}</p>
        <div>
          <span>{{ item.sendTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "tell",
  data() {
    return {
      tell_list: [],
      details: {},
    };
  },
  created() {
    this.dwon();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    async dwon() {
      let res = await this.$apis.userServe.systemMsg1();
      this.tell_list = res.data.list;
    },
    getDetails(item) {
      this.$router.push({ path: "/details", query: { id: item } });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.tell {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .tell_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }
  .tell_bottom {
    width: 100%;
    height: 100%;
    margin-top: 13px;
    .tell_bottom_list {
      width: 94%;
      height: 83px;
      background: #fff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      margin: 12px auto;
      overflow: hidden;
      p {
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        margin-left: 20px;
        margin-top: 21px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div {
        margin-top: 7px;
        span {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>